import { render } from "./DatosPersonales.vue?vue&type=template&id=62de94a5"
import script from "./DatosPersonales.vue?vue&type=script&lang=js"
export * from "./DatosPersonales.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__